import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { createAward } from '../../../api/award.api';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import AwardEditor from '../../../components/program/award/Editor';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import { IAwardModifyReq, IAwardReq } from '../../../models/award.model';

const ProgramAwardCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/program/award');
    }
  }, [res, isLoading]);

  const submit = (data: IAwardReq | IAwardModifyReq) => {
    execute(createAward(data as IAwardReq));
  };

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        parentMenu={t('program.award.title1')}
        currentMenu={t('program.award.title5')}
        iconFile="icon-program-big.svg"
      />
      <AwardEditor submit={submit} />
    </div>
  );
};

export default ProgramAwardCreate;
